import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The Principle of Charity in tech",
  "description": "",
  "published": "2019-06-05T00:00:00.000Z",
  "redirect_from": ["/blog/the-principle-of-charity-in-tech/swizec/9111"],
  "categories": "Opinions, Personal",
  "hero": "./img/CV5eqG9.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`My favorite part of posting on Reddit is saying `}<em parentName="p">{`"Hey look at this cool solution to an interesting problem I had"`}</em></p>
    <p>{`And the response is `}<em parentName="p">{`"This isn't a problem"`}</em></p>
    <p><img parentName="p" {...{
        "src": "/42a95aab392c4f5c0a4dc38b0702b44d/media-Pn1gZzAY38kbm-giphy.gif",
        "alt": "really giphy"
      }}></img></p>
    <p>{`Makes you wonder sometimes why you even bother doesn't it?`}</p>
    <p>{`Now between you and me, I'm used to it and that stuff doesn't get me. But what if I wasn't? What if that was my first time sharing something cool with the world?`}</p>
    <p>{`Let's say you're a newbie sharing some cool technique for the first time.`}</p>
    <p>{`You get a comment like this`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "826px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/89f22ad883512a6ac57f755fd0385c17/6a6e9/CV5eqG9.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "33.6322869955157%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'134\\'%20viewBox=\\'0%200%20400%20134\\'%20preserveAspectRatio=\\'none\\'/%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/89f22ad883512a6ac57f755fd0385c17/ca0a1/CV5eqG9.webp 223w", "/static/89f22ad883512a6ac57f755fd0385c17/75680/CV5eqG9.webp 445w", "/static/89f22ad883512a6ac57f755fd0385c17/40616/CV5eqG9.webp 826w"],
              "sizes": "(max-width: 826px) 100vw, 826px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/89f22ad883512a6ac57f755fd0385c17/e92b6/CV5eqG9.png 223w", "/static/89f22ad883512a6ac57f755fd0385c17/e66bf/CV5eqG9.png 445w", "/static/89f22ad883512a6ac57f755fd0385c17/6a6e9/CV5eqG9.png 826w"],
              "sizes": "(max-width: 826px) 100vw, 826px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/89f22ad883512a6ac57f755fd0385c17/6a6e9/CV5eqG9.png",
              "alt": "CV5eqG9",
              "title": "CV5eqG9",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Wow bummer ... you had a curious, albeit weird, problem and you solved it. You share with the world and `}<em parentName="p">{`"Yeah that's dumb, your problem is dumb, and wtf are you even doing!? How is it possible that you would ever need that? Get off my lawn"`}</em></p>
    <p>{`Maybe, just maybe, the author spent a little more time thinking about this than the commenter? 🤔`}</p>
    <p>{`What about a comment like this? Remember this is the same article and these are real comments.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "648px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/00ac60bddaef0d6aea64ffa3eaed2e98/3996e/HZ0pN7s.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "16.143497757847534%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'65\\'%20viewBox=\\'0%200%20400%2065\\'%20preserveAspectRatio=\\'none\\'/%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/00ac60bddaef0d6aea64ffa3eaed2e98/ca0a1/HZ0pN7s.webp 223w", "/static/00ac60bddaef0d6aea64ffa3eaed2e98/75680/HZ0pN7s.webp 445w", "/static/00ac60bddaef0d6aea64ffa3eaed2e98/f623b/HZ0pN7s.webp 648w"],
              "sizes": "(max-width: 648px) 100vw, 648px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/00ac60bddaef0d6aea64ffa3eaed2e98/e92b6/HZ0pN7s.png 223w", "/static/00ac60bddaef0d6aea64ffa3eaed2e98/e66bf/HZ0pN7s.png 445w", "/static/00ac60bddaef0d6aea64ffa3eaed2e98/3996e/HZ0pN7s.png 648w"],
              "sizes": "(max-width: 648px) 100vw, 648px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/00ac60bddaef0d6aea64ffa3eaed2e98/3996e/HZ0pN7s.png",
              "alt": "HZ0pN7s",
              "title": "HZ0pN7s",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`So much better!`}</p>
    <p>{`This commenter still has no idea `}<em parentName="p">{`why`}</em>{` you'd wanna use this technique or what makes it useful, `}<strong parentName="p"><em parentName="strong">{`but he's encouraging`}</em></strong>{`. Great experimentation! Keep going! Wonderful 🙌`}</p>
    <p>{`See the difference?`}</p>
    <p><img parentName="p" {...{
        "src": "/951418fc222c2bf9f7c7e3186f22f5f6/media-cXVRz41uYtSpAZGAwa-giphy.gif",
        "alt": "ah giphy"
      }}></img></p>
    <p>{`Shooting people down on the internet might make you feel cool but that shit's weak, my friend. You might think you're helping by poking holes in people's arguments, but you probably aren't.`}</p>
    <p>{`Not unless you have all the context.`}</p>
    <p>{`And yes I get it, it's up to the author to include enough context. Gotta explain `}<em parentName="p">{`why`}</em>{` you built it, `}<em parentName="p">{`why`}</em>{` you had the problem, and `}<em parentName="p">{`then`}</em>{` how you solved it.`}</p>
    <p>{`But then there's also this meme`}</p>
    <p><img parentName="p" {...{
        "src": "/ad205e2679c4af8909a2ff7b6f53104e/buzzfeed-static-static-2018-01-9-17-asset-buzzfeed-prod-fastlane-03-anigif_sub-buzz-15980-1515536728-1.gif",
        "alt": null
      }}></img></p>
    <p>{`You wouldn't read a 1000 word backstory anyway. 😉`}</p>
    <h2 {...{
      "id": "the-principle-of-charity"
    }}>{`The Principle of Charity`}</h2>
    <p>{`Instead, use the `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Principle_of_charity"
      }}>{`Principle of Charity`}</a>{` every time you read an article, have a technical debate, or discuss code with your team.`}</p>
    <blockquote>
      <p parentName="blockquote">{`In philosophy and rhetoric, the principle of charity or charitable interpretation requires interpreting a speaker's statements in the most rational way possible and, in the case of any argument, considering its best, strongest possible interpretation.`}</p>
    </blockquote>
    <p>{`Assume they're skilled, assume they had a good reason, assume there's constraints you don't know about.`}</p>
    <p>{`Ask questions.`}</p>
    <p>{`I can almost promise you that the article you're reading, the code you're reviewing, or the spec you're seeing for the first time – the author has spent more time thinking about it than you have.`}</p>
    <p>{`Respect that.`}</p>
    <p>{`You aren't clever when you point out every flaw.`}</p>
    <p>{`You're not showing off your smarts when you say `}<em parentName="p">{`"I'd never have that problem"`}</em>{`.`}</p>
    <p>{`You're not fooling anyone when you say `}<em parentName="p">{`"I could build that in an afternoon"`}</em></p>
    <p><em parentName="p">{`Helping`}</em>{` people improve is important. There's a time and place to point out flaws, question solutions, and suggest better ideas. But you gotta earn the right to do so. And that requires context.`}</p>
    <p>{`Anyway I hope you're not the kind of person who goes online and shoots people down, calls their ideas dumb, and questions their skills. If you are, please unfollow :P.`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      